import { css } from '@rxdi/lit-html';

export const BxDropdownStyle = css`
  bx-dropdown::part(trigger-button) {
    background: var(--bx-dropdown-background);
    outline: none;
  }
`;
